import React, {Component} from 'react';
import logo_pro from '../../cloud/image/stepByStep/logo_pro.png'
import title_pro from '../../cloud/image/stepByStep/title_pro.png'
import img_01 from '../../cloud/image/stepByStep/01.png'
import img_02 from '../../cloud/image/stepByStep/02.png'
import img_03 from '../../cloud/image/stepByStep/03.png'
import img_04 from '../../cloud/image/stepByStep/04.png'
import scan from '../../cloud/image/stepByStep/scan.png'
import qrcode from "../../../images/scanstep/scan_step_qrcode.png";

class CloudStepPro extends Component {
    render() {
        return (
            <div className={'cloud-step-max'}>
                <div className={'cloud-step-content'}>
                    <div className={'cloud-step-left'}>
                        <img src={logo_pro} className={'logo_pro'}/>
                        <img src={title_pro} className={'title_pro'}/>
                        <ul className={'step-list'}>
                            <li>
                                <img src={img_01}/>
                                提高客户运营效率，自动发欢迎语、通过好友请求、拉群打标签、发客户朋友圈
                            </li>
                            <li>
                                <img src={img_02}/>
                                提高社群运营效率，入群自动发欢迎语、智能拉群、群聊SOP、群活码，一个人即可运营上百个群聊，降低人工成本
                            </li>
                            <li>
                                <img src={img_03}/>
                                多号聚合聊天，解决大量企业微信消息分散在多个手机，无法统一及时回复的痛点，使消息回复时长缩短90%，十倍提升组织效率
                            </li>
                            <li>
                                <img src={img_04}/>
                                消息群发，消息SOP，不限次数发送，实现用户画像、用户分层、千人前面的用户触达
                            </li>
                        </ul>
                    </div>
                    <div className={'cloud-step-right'}>
                        <div className={'title-s1'}>扫码添加客服微信</div>
                        <div className={'title-s1'}>联系客户开通产品试用</div>
                        <div className={'step-qr-code-max'}>
                            <img src={qrcode}/>
                        </div>
                        <div className={'scan-desc'}>
                            <img src={scan}/>
                            <span>请扫码联系客服开通</span>
                        </div>
                        <div className={'title-s2'}>新用户可免费试用</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CloudStepPro;